import React from 'react'
import type { BaseWeatherIconProps } from '../WeatherIcon'

const WeatherIconNightSnowShower: React.FC<BaseWeatherIconProps> = ({
  className = '',
}) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 100 100"
      fill="none"
      className={className}
    >
      <path
        d="M18.5989 47.2935C15.4279 41.9148 14.1835 35.372 15.5483 28.7891C18.2376 15.6634 30.4 6.87279 43.4855 8.11712C44.4087 8.1974 45.3721 8.31782 46.3354 8.51852C47.3791 8.75935 48.3826 9.04033 49.3861 9.36145C47.66 10.1642 46.0143 11.1276 44.5292 12.2916C40.7159 15.4225 37.866 19.7978 36.8223 25.0159C36.3808 27.1433 36.2604 29.2306 36.4209 31.2777C34.7351 33.1242 33.3703 35.2114 32.3668 37.5395C26.3057 38.3022 21.1678 42.0753 18.5989 47.2935Z"
        fill="#D2D4DA"
      />
      <path
        d="M75.9193 50.3444H71.3033V45.8889C71.3033 36.0547 63.1148 28.0669 52.9594 28.0669C46.4166 28.0669 40.6767 31.4386 37.4655 36.4561C36.462 37.9814 35.7395 39.6673 35.2578 41.4334H34.6156C28.3136 41.4334 23.0152 45.5277 21.3695 51.1472C21.0082 52.3113 20.8477 53.5155 20.8477 54.7999C20.8477 62.1856 27.0292 68.2066 34.6156 68.2066H75.9193C80.9769 68.2066 85.0712 64.1926 85.0712 59.2554C85.0712 54.3584 80.9769 50.3444 75.9193 50.3444Z"
        fill="#87D6F8"
      />
      <path
        d="M55.0793 79.0038L57.4074 82.215L54.9588 83.9811L52.6709 80.77L50.3428 83.9811L47.8943 82.215L50.2224 79.0038L46.4492 77.7996L47.4126 74.9497L51.1456 76.1539V72.2202H54.156V76.1539L57.9292 74.9497L58.8524 77.7996L55.0793 79.0038Z"
        fill="#D2E0FF"
      />
      <path
        d="M41.8639 78.9439L38.1109 80.1681V76.2144H35.1004V80.1681L31.3473 78.9439L30.4141 81.8038L34.1671 83.0281L31.8491 86.2292L34.2775 87.9954L36.6056 84.7942L38.9237 87.9954L41.3622 86.2292L39.0341 83.0281L42.7972 81.8038L41.8639 78.9439Z"
        fill="#D2E0FF"
      />
      <path
        d="M74.9124 85.817L73.9791 82.957L70.2261 84.1813V80.2275H67.2156V84.1813L63.4625 82.957L62.5293 85.817L66.2824 87.0412L63.9643 90.2424L66.4028 92.0085L68.7208 88.8174L71.0389 92.0085L73.4774 90.2324L71.1593 87.0412L74.9124 85.817Z"
        fill="#D2E0FF"
      />
    </svg>
  )
}

export default WeatherIconNightSnowShower
